import styled from 'styled-components';
import { WrapperDefault } from '../../Shared/Shared';
export const FormInfoWrapper = styled(WrapperDefault)`
  gap: 15px;
`;

export const FormBody = styled.p`
  margin-top: 24px;
  margin-bottom: 42px;
  font-weight: 500;
  line-height: 1.45;
  font-size: 20px;
`;
